module.exports = __webpack_public_path__ + "static/media/office8.fa8f2baa.jpg";